import Intercom, { hide, shutdown, update } from '@intercom/messenger-js-sdk';

export const bootIntercom = (user: any) => {
  Intercom({
    app_id: 'r5f5cc13',
    intercom_user_jwt: user.intercomJWT,
    user_id: user.userId,
    name: user.email,
    email: user.email,
    client_name: user.clientName,
    pms: user.pms,
    alignment: 'right',
    horizontal_padding: 100,
    vertical_padding: 35,
  });
};

export const shutdownIntercom = () => {
  shutdown();
  hide();
};

export const updateIntercom = () => {
  update();
};
